// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__3KcJ3","content":"styles_content__27MLj","checkbox":"styles_checkbox__1DYgw","checkboxLabel":"styles_checkboxLabel__URHzN"};